<template>
  <el-main>
    <el-row>      
      数据管理:项目=>{{ sel_xm }}{{ ' ' }}学校=>{{ user_school }}
    </el-row>
    <el-row>
        <el-tabs v-model="activeName" type="border-card"    @tab-click="handleClick" >
              <el-tab-pane  name="0" label="学生信息管理" >
                  <el-row> 
                      <vxe-toolbar>
                            <template v-slot:buttons>
                              <a-space>
                              <a-icon type="team" />
                              <vxe-button icon="vxe-icon-square-plus" @click="insertOneSt()">新增单个学生</vxe-button>
                              <vxe-button @click="importSt">导入</vxe-button> 
                              <vxe-button @click="exportSt">导出</vxe-button> 
                              <vxe-button @click="getSchoolStudent">刷新</vxe-button>                              
                              <vxe-input v-model="filterName1" type="search" placeholder="输入考号或者姓名搜索" @keyup="searchEvent1"></vxe-input>
                              <vxe-button @click="emptySchoolSt">清空学生</vxe-button> 
                              </a-space>
                        </template> 
                      </vxe-toolbar>
                    <vxe-table
                        ref="xTable"
                        height="400"
                        border
                        :row-config="{height: 20,isCurrent: true, isHover: true}"
                        :loading="loading"
                        :seq-config="{startIndex: 0}"
                        :data="StData">                      
                        <vxe-column field="kh"  title="考号" sortable></vxe-column>
                        <vxe-column field="nm" title="姓名"></vxe-column>
                        <vxe-column field="sc" title="学校"></vxe-column>  
                        <vxe-column field="cls" title="班级"></vxe-column>  
                        <vxe-column field="kb" title="科别"></vxe-column>    
                        <vxe-column field="kc" title="考场"></vxe-column>
                        <vxe-column field="zh" title="座号"></vxe-column>
                        <vxe-column title="操作" width="100" show-overflow>
                          <template #default="{ row }">             
                            <vxe-button type="text" icon="vxe-icon-delete" @click="removeEvent(row)"></vxe-button>
                          </template>
                        </vxe-column>
                    </vxe-table>
                    {{totalRowsSt}}条记录
                      <vxe-modal v-model="showEdit" :title="selectRow ? '增加单个学生' : '增加单个学生'" width="800" min-width="600" min-height="300" resize destroy-on-close>
                        <template #default>
                          <vxe-form :data="formData" :rules="formRules" title-align="right" title-width="100" @submit="submitEvent">

                            <vxe-form-item field="kh" title="考号" :span="12" :item-render="{}">
                              <template #default="{ data }">
                                <vxe-input v-model="data.kh" placeholder="请输入考号"></vxe-input>
                              </template>
                            </vxe-form-item>

                            <vxe-form-item field="nm" title="姓名" :span="12" :item-render="{}">
                              <template #default="{ data }">
                                <vxe-input v-model="data.nm" placeholder="请输入名称"></vxe-input>
                              </template>
                            </vxe-form-item>
                         
                            <vxe-form-item field="sc" title="学校" :span="12" :item-render="{}">
                              <template #default="{ data }">
                                <vxe-input v-model="data.sc" placeholder="请输入学校" readonly></vxe-input>
                              </template>
                            </vxe-form-item>

                            <vxe-form-item field="cls" title="班级" :span="12" :item-render="{}">
                              <template #default="{ data }">
                                <vxe-input v-model="data.cls" placeholder="请输入班级"></vxe-input>
                              </template>
                            </vxe-form-item>
                            <vxe-form-item field="kb" title="科别" :span="12" :item-render="{}">
                              <template #default="{ data }">
                                <vxe-input v-model="data.kb" placeholder="请输入科别"></vxe-input>
                              </template>
                            </vxe-form-item>

                            <vxe-form-item field="kc" title="考场" :span="12" :item-render="{}">
                              <template #default="{ data }">
                                <vxe-input v-model="data.kc" placeholder="请输入考场"></vxe-input>
                              </template>
                            </vxe-form-item>

                            <vxe-form-item field="zh" title="座号" :span="12" :item-render="{}">
                              <template #default="{ data }">
                                <vxe-input v-model="data.zh" placeholder="请输入座号"></vxe-input>
                              </template>
                            </vxe-form-item>


                         
                            
                            <vxe-form-item align="center" title-align="left" :span="24">
                              <template #default>
                                <vxe-button type="submit">提交</vxe-button>                             
                              </template>
                            </vxe-form-item>
                          </vxe-form>
                        </template>
                      </vxe-modal>

                          <el-dialog :title="title" :visible.sync="dialogTableVisible" :close-on-press-escape="false" :close-on-click-modal="false">
                            <a-space>  
                            {{ user_school }}
                              <vxe-button @click="exportStYangbiao">下载导入样表</vxe-button> 
                              <input type="file" ref="stFile" @change="importData">
                            </a-space>
                              <vxe-table
                                ref="xTableImport"
                                height="400"  
                                border
                                :seq-config="{startIndex: 0}"
                                :data="importStData">
                                <vxe-column type="seq" title="序号"  ></vxe-column>
                                <vxe-column field="kh"  title="考号" sortable></vxe-column>
                                <vxe-column field="nm" title="姓名"></vxe-column>
                                <vxe-column field="sc" title="学校"></vxe-column>  
                                <vxe-column field="cls" title="班级"></vxe-column>  
                                <vxe-column field="kb" title="科别"></vxe-column>    
                                <vxe-column field="kc" title="考场"></vxe-column>
                                <vxe-column field="zh" title="座号"></vxe-column>                
                            </vxe-table>
                            <vxe-button @click="importSvrEvent">导入到服务器</vxe-button> 
                        </el-dialog> 

                  </el-row>    
              </el-tab-pane>    
              <el-tab-pane  name="1" label="教师信息管理" >
                <el-row> 
                      <vxe-toolbar>
                            <template v-slot:buttons>
                              <a-space>
                              <vxe-button icon="vxe-icon-square-plus" @click="insertOneTeacher()">新增单个教师</vxe-button>
                              <vxe-button @click="importTeacher">导入</vxe-button> 
                              <vxe-button @click="exportTeacherData">导出</vxe-button> 
                              <vxe-button @click="getSchoolTeacher">刷新</vxe-button>                               
                              <vxe-input v-model="filterName2" type="search" placeholder="输入手机号或姓名搜索" @keyup="searchEvent2"></vxe-input>
                              <vxe-button @click="emptySchoolTeacher">清空教师</vxe-button>  
                             </a-space>
                        </template> 
                      </vxe-toolbar>
                    <vxe-table
                        ref="xTable"
                        height="400"
                        border
                        :row-config="{height: 20,isCurrent: true, isHover: true}"
                        :loading="loading"
                        :seq-config="{startIndex: 0}"
                        :data="teacherData">                      
                        <vxe-column field="zh"  title="手机号" sortable></vxe-column>
                        <vxe-column field="nm" title="姓名"></vxe-column>
                        <vxe-column field="km" title="科目"></vxe-column>  
                        <vxe-column field="sc" title="学校"></vxe-column>  
                        <vxe-column field="grade" title="年级"></vxe-column>    

                        <vxe-column title="操作" width="100" show-overflow>
                          <template #default="{ row }">             
                            <vxe-button type="text" icon="vxe-icon-delete" @click="removeTeacher(row)"></vxe-button>
                          </template>
                        </vxe-column>
                    </vxe-table>
                    {{totalRowsTeacher}}条记录
                
                      <vxe-modal v-model="showEdit" :title="selectRow ? '增加单个教师' : '增加单个教师'" width="800" min-width="600" min-height="300" resize destroy-on-close>
                        <template #default>
                          <vxe-form :data="formDataTeacher" :rules="formRulesTeacher" title-align="right" title-width="100" @submit="submitTeacherEvent">

                            <vxe-form-item field="zh" title="手机号" :span="12" :item-render="{}">
                              <template #default="{ data }">
                                <vxe-input v-model="data.zh" placeholder="请输入手机号"></vxe-input>
                              </template>
                            </vxe-form-item>

                            <vxe-form-item field="nm" title="姓名" :span="12" :item-render="{}">
                              <template #default="{ data }">
                                <vxe-input v-model="data.nm" placeholder="请输入姓名"></vxe-input>
                              </template>
                            </vxe-form-item>

                            <vxe-form-item field="km" title="科目" :span="12" :item-render="{}">
                              <template #default="{ data }">
                                <vxe-input v-model="data.km" placeholder="请输入科目"></vxe-input>
                              </template>
                            </vxe-form-item>
                         
                            <vxe-form-item field="sc" title="学校" :span="12" :item-render="{}">
                              <template #default="{ data }">
                                <vxe-input v-model="data.sc" placeholder="请输入学校" readonly></vxe-input>
                              </template>
                            </vxe-form-item>

                            <vxe-form-item field="grade" title="年级" :span="12" :item-render="{}">
                              <template #default="{ data }">
                                <vxe-input v-model="data.grade" placeholder="请输入年级"></vxe-input>
                              </template>
                            </vxe-form-item>                    

                         
                            
                            <vxe-form-item align="center" title-align="left" :span="24">
                              <template #default>
                                <vxe-button type="submit">提交</vxe-button>                             
                              </template>
                            </vxe-form-item>
                          </vxe-form>
                        </template>
                      </vxe-modal>

                          <el-dialog :title="title" :visible.sync="dialogTeacherTableVisible" :close-on-press-escape="false" :close-on-click-modal="false">
                            <a-space>
                            {{ user_school }}
                              <vxe-button @click="exportTeacherYangbiao">下载导入样表</vxe-button> 
                              <input type="file" ref="teacherFile" @change="importDataTeacher">
                            </a-space>
                              <vxe-table
                                ref="xTableImport"
                                height="400"  
                                border
                                :seq-config="{startIndex: 0}"
                                :data="importTeacherData">
                                <vxe-column type="seq" title="序号"  ></vxe-column>
                                <vxe-column field="zh"  title="手机号" sortable></vxe-column>
                                <vxe-column field="nm" title="姓名"></vxe-column>
                                <vxe-column field="km" title="科目"></vxe-column>  
                                <vxe-column field="sc" title="学校"></vxe-column>  
                                <vxe-column field="grade" title="年级"></vxe-column>    
                                 
                            </vxe-table>
                            <vxe-button @click="importTeacherSvrEvent">导入到服务器</vxe-button> 
                        </el-dialog> 

                  </el-row>  
              </el-tab-pane>  
        </el-tabs>
    </el-row>

  </el-main>
</template>
<script>
	import axios from 'axios'
	import qs from 'qs'
	import localStorage from 'localStorage'
  import ExcelJS from 'exceljs'
  import FileSaver from 'file-saver'
  import XEUtils from 'xe-utils'
  import VXETable from 'vxe-table'  
import { saveAs } from "file-saver";

	export default {
		data() {
		  return {
      showEdit:false,
			menulist: [],
      user_school:'',
      activeName: '0',
      tableImport: {
                // 自定义类型
                types: ['xlsx']
              },
      svrStData: [
      ],
      svrTeacherData: [
      ],
      imortStData: [
      ],
      StData:[],
      teacherData:[],
      tmpStData:[],
      importStData:[],
      importTeacherData:[],
      dialogTableVisible: false,
      dialogTeacherTableVisible:false,
      filterName: '',
      tablePage1: {
                currentPage: 1,
                pageSize: 100,
                totalResult: 0
              },
              filterName1:'',      
      filterName2: '',
      tablePage2: {
                currentPage: 1,
                pageSize: 100,
                totalResult: 0
              },
		 
				sel_xm:'',
        sel_sb:'',
        sel_tizu:'',
        is_disable:true,
				is_jindu_disable:true,
				options:[],
				cascagerdefault: ["0", "0", ""],
        grade:'',
        formData: {
                kh: null,
                nm: null,
                sc: null,
                cls: null,
                kb: null,
                kc: null,
                zh: null,
              },
        formRules: {
          kh: [
            { required: true, message: '请输入考号' },
            { min: 3, max: 20, message: '长度在 3 到 20个字符' }
          ],
          nm: [
            { required: true, message: '请输入姓名' }
          ],
          sc: [
            { required: true, message: '请输入学校' }
          ],
          cls: [
            { required: true, message: '请输入班级' }
          ],
          kb: [
            { required: true, message: '请输入科别' }
          ],
          kc: [
            { required: true, message: '请输入考场' }
          ],
          zh: [
            { required: true, message: '请输入座号' }
          ]
        },

        formDataTeacher: {
                zh: null,
                nm: null,
                km: null,
                sc: null,                
                grade: null,           
              },
        formRulesTeacher: {
          zh: [
            { required: true, message: '请输入手机号' },
            { min: 11, max: 11, message: '长度11位手机号' }
          ],
          nm: [
            { required: true, message: '请输入姓名' }
          ],
          km: [
            { required: true, message: '请输入科目' }
          ],
          sc: [
            { required: true, message: '请输入学校' }
          ],
          grade: [
            { required: true, message: '请输入年级' }
          ],
          
        },
        loading:false,
        totalRowsTeacher:0,
        totalRowsSt:0,


				
		  };
		},
    created () {
            this.searchEvent1()
            this.searchEvent2()
          },
		mounted:function(){
		},

    activated() {

      this.getopt();//需要触发的函数

      },
          
	
		methods: {
      insertOneSt () {
              this.formData = {
                kh: '',
                nm: '',
                sc: this.user_school,
                cls: '',
                kb: '',
                kc: '',        
                zh: '',
              }
              this.selectRow = null
              this.showEdit = true
        },
        insertOneTeacher () {
              this.formDataTeacher = {
                zh: '',
                nm: '',
                km:'',
                sc: this.user_school,
                grade: '',
              }
              this.selectRow = null
              this.showEdit = true
        },
          async removeEvent (row) {
              console.log(row['kh'],row['nm'])
              let kh=row['kh']
              const type = await VXETable.modal.confirm('您确定要删除考号:'+kh+'的学生信息吗?')
              const $table = this.$refs.xTable
              if (type === 'confirm') {
                $table.remove(row)
                let svr_yuming=localStorage.getItem('svr_yuming')
                axios.post('/scoreman?op=delOneSchoolStudent',qs.stringify({"svr_yuming":svr_yuming,"grade":this.grade,"kaohao":kh})).then((res)=>{
                      console.log(res.data)
                      this.$alert(res.data, '提示', {
                          confirmButtonText: '确定',                 
                        })
                        this.totalRowsSt=this.totalRowsSt-1
                  }).catch((res)=>{
                  }) 
              }
            },

            async removeTeacher (row) {
              console.log(row['zh'],row['nm'])
              let zh=row['zh']
              const type = await VXETable.modal.confirm('您确定要删除手机号:'+zh+'的教师信息吗?')
              const $table = this.$refs.xTable
              if (type === 'confirm') {
                $table.remove(row)
                let svr_yuming=localStorage.getItem('svr_yuming')
                axios.post('/scoreman?op=delOneSchoolTeacher',qs.stringify({"svr_yuming":svr_yuming,"zh":zh})).then((res)=>{
                      console.log(res.data)
                      this.$alert(res.data, '提示', {
                          confirmButtonText: '确定',                 
                        })
                        this.totalRowsTeacher=this.totalRowsTeacher-1
                  }).catch((res)=>{
                  }) 
              }
            },
            async emptySchoolSt(){              
             
              const type = await VXETable.modal.confirm('您确定要清空:'+this.user_school+'的学生信息吗?')
              const $table = this.$refs.xTable
              if (type === 'confirm') {
                let svr_yuming=localStorage.getItem('svr_yuming')
                axios.post('/scoreman?op=emptySchoolStudent',qs.stringify({"svr_yuming":svr_yuming,"grade":this.grade})).then((res)=>{
                      console.log(res.data)
                      this.$alert(res.data, '提示', {
                          confirmButtonText: '确定',                 
                        })
                  }).catch((res)=>{
                  }) 
              }
            },
            async emptySchoolTeacher(){
              const type = await VXETable.modal.confirm('您确定要清空:'+this.user_school+'的教师信息吗?')
              const $table = this.$refs.xTable
              if (type === 'confirm') {
                let svr_yuming=localStorage.getItem('svr_yuming')               
                axios.post('/scoreman?op=emptySchoolTeacher',qs.stringify({"svr_yuming":svr_yuming,"grade":this.grade})).then((res)=>{
                      console.log(res.data)
                      this.$alert(res.data, '提示', {
                          confirmButtonText: '确定',                 
                        })
                  }).catch((res)=>{
                  }) 
              }
            },

          checkkebie(stkebie)
          {
              let kebie=0
              if (stkebie.indexOf('理')>-1)
              {
                kebie=1
              }
              else if (stkebie.indexOf('文')>-1)
              {
                kebie=2
              }
              else if (stkebie.indexOf('物')>-1||stkebie.indexOf('化')>-1||stkebie.indexOf('生')>-1)
              {
                kebie=3
              }
              else if (stkebie.indexOf('物')>-1||stkebie.indexOf('化')>-1||stkebie.indexOf('政')>-1)
              {
                kebie=4
              }
              else if (stkebie.indexOf('物')>-1||stkebie.indexOf('化')>-1||stkebie.indexOf('历')>-1||stkebie.indexOf('史')>-1)
              {
                kebie=5
              }
              else if (stkebie.indexOf('物')>-1||stkebie.indexOf('化')>-1||stkebie.indexOf('地')>-1)
              {
                kebie=6
              }
              return kebie
          },
           searchEvent1 () {
              const filterName = XEUtils.toValueString(this.filterName1).trim().toLowerCase()
              if (filterName) {
                const filterRE = new RegExp(filterName, 'gi')
                const searchProps = ['kh', 'nm']
                const rest = this.svrStData.filter(item => searchProps.some(key => XEUtils.toValueString(item[key]).toLowerCase().indexOf(filterName) > -1))
                this.StData = rest.map(row => {
                  const item = Object.assign({}, row)
                  searchProps.forEach(key => {
                    item[key] = XEUtils.toValueString(item[key]).replace(filterRE, match => `${match}`)
                  })
                  return item
                })
              } else {
                this.StData = this.svrStData
              }
            },

            searchEvent2 () {
              
              const filterName = XEUtils.toValueString(this.filterName2).trim().toLowerCase()
              
              if (filterName) {
                console.log('ok1')
                const filterRE = new RegExp(filterName, 'gi')
                const searchProps = ['zh','nm']
                const rest = this.svrTeacherData.filter(item => searchProps.some(key => XEUtils.toValueString(item[key]).toLowerCase().indexOf(filterName) > -1))
                this.teacherData = rest.map(row => {
                  const item = Object.assign({}, row)
                  searchProps.forEach(key => {
                    item[key] = XEUtils.toValueString(item[key]).replace(filterRE, match => `${match}`)
                  })
                  return item
                })
                console.log(this.teacherData)
              } else {
                
                this.teacherData = svrTeacherData
                console.log('ok2')
                console.log(this.teacherData)
              }
            },
		
      handleClick(tab, event) {
        console.log(tab, event)
        console.log(this.activeName)
        if (this.activeName==0)
        {
            this.getSchoolStudent()
        }
        else
        {
            this.getSchoolTeacher()
        }
        //获取对应科目上传信息
      },

      importData(event) {
          let file = event.target.files[0]
          let reader = new FileReader()

          reader.onload = () => {
            console.log('111')
            let buffer = reader.result
            let workbook = new ExcelJS.Workbook()

            workbook.xlsx.load(buffer).then(() => {
              let worksheet = workbook.worksheets[0]
              //检测导入表题头是否合规 begin
              let dataIsValid=true
              if (worksheet.columns.length>=7)
              {
                let column = worksheet.columns[0];
                if (column.values[1]!='考号')
                {
                  dataIsValid=false
                }
                   column = worksheet.columns[1];
                if (column.values[1]!='姓名')
                {
                  dataIsValid=false
                }
                column = worksheet.columns[2];
                if (column.values[1]!='学校')
                {
                  dataIsValid=false
                }
                column = worksheet.columns[3];
                if (column.values[1]!='班级')
                {
                  dataIsValid=false
                }
                column = worksheet.columns[4];
                if (column.values[1]!='科别')
                {
                  dataIsValid=false
                }
                column = worksheet.columns[5];
                if (column.values[1]!='考场')
                {
                  dataIsValid=false
                }
                column = worksheet.columns[6];
                if (column.values[1]!='座号')
                {
                  dataIsValid=false
                }

              }
              else
              {
                dataIsValid=false
              }
              //检测导入表题头是否合规 end
              if (dataIsValid==true)
              {
                  this.importStData = []
                  for (let i = 2; i <= worksheet.rowCount; i++) {
                    let kh = worksheet.getCell(`A${i}`).value
                    let nm= worksheet.getCell(`B${i}`).value
                    let sc = worksheet.getCell(`C${i}`).value
                        sc=this.user_school
                    let cls= worksheet.getCell(`D${i}`).value
                    let kb = worksheet.getCell(`E${i}`).value
                    kb=this.checkkebie(kb)
                    let kc= worksheet.getCell(`F${i}`).value
                    if (kc==null)
                    {
                      kc=''
                    }
                    let zh= worksheet.getCell(`G${i}`).value
                    if (zh==null)
                    {
                      zh=''
                    }
                    this.importStData.push({ kh,nm,sc,cls,kb,kc,zh })
                  }
                   
              }
              else
              {
                this.$alert('导入数据不合规,请下载样表!', '提示', {
                  confirmButtonText: '确定',
                 
                })
              }
            })
            
          }

          reader.readAsArrayBuffer(file)
          this.$refs.stFile.value = ''
        },
  
    importDataTeacher(event) {
          let file = event.target.files[0]
          let reader = new FileReader()

          reader.onload = () => {
            
            let buffer = reader.result
            let workbook = new ExcelJS.Workbook()

            workbook.xlsx.load(buffer).then(() => {
              let worksheet = workbook.worksheets[0]
              //检测导入表题头是否合规 begin
              let dataIsValid=true
              if (worksheet.columns.length>=5)
              {
                console.log('xxxxx')
                let column = worksheet.columns[0];
                if (column.values[1]!='手机号')
                {
                  dataIsValid=false
                  console.log('手机号')
                }
                   column = worksheet.columns[1];
                if (column.values[1]!='姓名')
                {
                  dataIsValid=false
                  console.log('姓名')
                  console.log(column.values[1])
                  
                }
                column = worksheet.columns[2];
                if (column.values[1]!='科目')
                {
                  dataIsValid=false
                  console.log('科目')
                }
                column = worksheet.columns[3];
                if (column.values[1]!='学校')
                {
                  dataIsValid=false
                  console.log('学校')
                }
                column = worksheet.columns[4];
                if (column.values[1]!='年级')
                {
                  dataIsValid=false
                  console.log('年级')
                }
              

              }
              else
              {
                dataIsValid=false
              }
              //检测导入表题头是否合规 end
              if (dataIsValid==true)
              {
                  this.importTeacherData = []
                  for (let i = 2; i <= worksheet.rowCount; i++) {
                    let zh = worksheet.getCell(`A${i}`).value
                    let nm= worksheet.getCell(`B${i}`).value
                    
                    let km= worksheet.getCell(`C${i}`).value
                    let sc = worksheet.getCell(`D${i}`).value
                        sc=this.user_school
                    let grade = worksheet.getCell(`E${i}`).value
                    
                    this.importTeacherData.push({ zh,nm,km,sc,grade})
                  }
              }
              else
              {
                this.$alert('导入数据不合规,请下载教师信息样表!', '提示', {
                  confirmButtonText: '确定',
                 
                })
              }
            })
            
          }

          reader.readAsArrayBuffer(file)
          this.$refs.teacherFile.value = ''
        },
        saveFile() {
          const text = "要保存的文本内容";
          const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
          const filename = "example.txt";
          if (window.navigator.msSaveOrOpenBlob) {
            // IE10+
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            // 非IE浏览器
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
        },
        exportSt() {
              const workbook = new ExcelJS.Workbook()
              const worksheet = workbook.addWorksheet('Students')

              // 添加表头
              worksheet.addRow(['考号', '姓名','学校','班级','科别','考场','座号'])

              // 添加数据
              this.svrStData.forEach(student => {
                worksheet.addRow([student.kh, student.nm,student.sc,student.cls,student.kb,student.kc,student.zh])
              })
              

              // 导出Excel文件
              workbook.xlsx.writeBuffer().then(buffer => {
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                //自动列宽 begin
                for (let i = 0; i < worksheet.columns.length; i += 1) { 
                    let dataMax = 0;
                    const column = worksheet.columns[i];
                    for (let j = 1; j < column.values.length; j += 1) {
                      const columnLength = column.values[j].length;
                      if (columnLength > dataMax) {
                        dataMax = columnLength;
                      }
                    }
                    column.width = dataMax < 10 ? 10 : dataMax;
                  }
                 //自动列宽 end

                const filename = "导出" + ".xlsx";
               // saveAs(blob, filename);
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = 'students.xlsx'
                link.click()
                window.URL.revokeObjectURL(url)
              })
            },
            exportTeacherData() {
              const workbook = new ExcelJS.Workbook()
              const worksheet = workbook.addWorksheet('Students')

              // 添加表头
              worksheet.addRow(['手机号', '姓名','科目','学校','年级'])

              // 添加数据
              this.svrTeacherData.forEach(teacher => {
                worksheet.addRow([teacher.zh, teacher.nm,teacher.km,teacher.sc,teacher.grade])
              })
              

              // 导出Excel文件
              workbook.xlsx.writeBuffer().then(buffer => {
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                //自动列宽 begin
                for (let i = 0; i < worksheet.columns.length; i += 1) { 
                    let dataMax = 0;
                    const column = worksheet.columns[i];
                    for (let j = 1; j < column.values.length; j += 1) {
                      const columnLength = column.values[j].length;
                      if (columnLength > dataMax) {
                        dataMax = columnLength;
                      }
                    }
                    column.width = dataMax < 10 ? 10 : dataMax;
                  }
                 //自动列宽 end

                const filename = "导出" + ".xlsx";
               // saveAs(blob, filename);
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = 'teacher.xlsx'
                link.click()
                window.URL.revokeObjectURL(url)
              })
            },
            exportStYangbiao() {
              const workbook = new ExcelJS.Workbook()
              const worksheet = workbook.addWorksheet('Students')

              // 添加表头
              worksheet.addRow(['考号', '姓名','学校','班级','科别','考场','座号'])

              // 添加数据
              worksheet.addRow(['1122334455', '张三',this.user_school,'1班','理科','01','01'])

              // 导出Excel文件
              workbook.xlsx.writeBuffer().then(buffer => {
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                //自动列宽 begin
                for (let i = 0; i < worksheet.columns.length; i += 1) { 
                    let dataMax = 0;
                    const column = worksheet.columns[i];
                    for (let j = 1; j < column.values.length; j += 1) {
                      const columnLength = column.values[j].length;
                      if (columnLength > dataMax) {
                        dataMax = columnLength;
                      }
                    }
                    column.width = dataMax < 10 ? 10 : dataMax;
                  }
                 //自动列宽 end

                const filename = "学生样表" + ".xlsx";
               // saveAs(blob, filename);
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = filename
                link.click()
                window.URL.revokeObjectURL(url)
              })
            },
 
            exportTeacherYangbiao() {
              const workbook = new ExcelJS.Workbook()
              const worksheet = workbook.addWorksheet('teacher')

              // 添加表头
              worksheet.addRow(['手机号', '姓名','科目','学校','年级'])

              // 添加数据
              worksheet.addRow(['13011112222', '张三','语文',this.user_school,'高三'])

              // 导出Excel文件
              workbook.xlsx.writeBuffer().then(buffer => {
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                //自动列宽 begin
                for (let i = 0; i < worksheet.columns.length; i += 1) { 
                    let dataMax = 0;
                    const column = worksheet.columns[i];
                    for (let j = 1; j < column.values.length; j += 1) {
                      const columnLength = column.values[j].length;
                      if (columnLength > dataMax) {
                        dataMax = columnLength;
                      }
                    }
                    column.width = dataMax < 10 ? 10 : dataMax;
                  }
                 //自动列宽 end

                const filename = "教师导入信息样表" + ".xlsx";
               // saveAs(blob, filename);
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = filename
                link.click()
                window.URL.revokeObjectURL(url)
              })
            },
 
		 
            importSt() {
              this.importStData=[]
              this.dialogTableVisible = true
            },

            importTeacher() {
              this.importTeacherData=[]
              this.dialogTeacherTableVisible = true
            },
            
    
            
            getopt(){		
                         console.log('请求开始');
            
                        this.sel_xm=localStorage.getItem('xm')
                        let kemul=localStorage.getItem('kemu')
                        this.menulist=[]
                        this.menulist.push('学生信息管理')
                        this.menulist.push('教师信息管理')

                        let xm=this.sel_xm

                        let grade=xm.substring(xm.indexOf('(')+1,xm.indexOf(')'))
                        console.log('年级:'+grade);	
                        this.grade=grade
                        this.user_school=localStorage.getItem('user_school');
                        console.log(localStorage.getItem('user_yuming'));					
                        console.log(localStorage.getItem('user_school'));		
                        //获取已传学生数据
                        this.getSchoolStudent()
            },

      getSchoolStudent () { 
         this.loading=true
         this.svrStData=[]
         this.StData=[]
         this.filterName1=''
         this.tablePage1 = {           
                currentPage: 1,
                pageSize: 100,
                totalResult: 0
          }
          let svr_yuming=localStorage.getItem('svr_yuming')
         axios.post('/scoreman?op=getSchoolStudent',qs.stringify({"svr_yuming":svr_yuming,"grade":this.grade})).then((res)=>{
               console.log(res.data)
               this.svrStData=res.data        
               this.totalRowsSt=this.svrStData.length
               this.tablePage1.totalResult = this.svrStData.length
               this.StData = this.svrStData.slice((this.tablePage1.currentPage - 1) * this.tablePage1.pageSize, this.tablePage1.currentPage * this.tablePage1.pageSize)       
               this.loading=false
           }).catch((res)=>{
               this.loading=false
           })
       },

       getSchoolTeacher () { 
         this.loading=true
         this.svrTeacherData=[]
         this.teacherData=[]
         this.tablePage2 = {           
                currentPage: 1,
                pageSize: 100,
                totalResult: 0
          }

         let svr_yuming=localStorage.getItem('svr_yuming')
         this.filterName2=''
         axios.post('/scoreman?op=getSchoolTeacher',qs.stringify({"svr_yuming":svr_yuming,"grade":this.grade})).then((res)=>{
               console.log(res.data)
               this.svrTeacherData=res.data        
               this.totalRowsTeacher=this.svrTeacherData.length
               this.tablePage2.totalResult = this.svrTeacherData.length
               this.teacherData = this.svrTeacherData.slice((this.tablePage2.currentPage - 1) * this.tablePage2.pageSize, this.tablePage2.currentPage * this.tablePage2.pageSize)       
               this.loading=false
           }).catch((res)=>{
              this.loading=false
           })
       },


    importSvrEvent() {              
         let svr_yuming=localStorage.getItem('svr_yuming')
         axios.post('/scoreman?op=importSchoolStudent',qs.stringify({"svr_yuming":svr_yuming,"grade":this.grade,"stdata":JSON.stringify(this.importStData)})).then((res)=>{
               console.log(res.data)

               this.$alert(res.data, '提示', {
                  confirmButtonText: '确定',                 
                })
               
           }).catch((res)=>{
           })
   },

   importTeacherSvrEvent() {              
         let svr_yuming=localStorage.getItem('svr_yuming')
         axios.post('/scoreman?op=importSchoolTeacher',qs.stringify({"svr_yuming":svr_yuming,"teachertdata":JSON.stringify(this.importTeacherData)})).then((res)=>{
               console.log(res.data)

               this.$alert(res.data, '提示', {
                  confirmButtonText: '确定',
                 
                })
               
           }).catch((res)=>{
              
           })
   },


   findList1 () {
               this.tablePage1.totalResult = this.svrStData.length
               this.StData = this.svrStData.slice((this.tablePage1.currentPage - 1) * this.tablePage1.pageSize, this.tablePage1.currentPage * this.tablePage1.pageSize)       

   },

    handlePageChange1 ({ currentPage, pageSize }) {
              this.tablePage1.currentPage = currentPage
              this.tablePage1.pageSize = pageSize
              this.findList1()
            },
    //增加单个学生        
    submitEvent () {
      let svr_yuming=localStorage.getItem('svr_yuming')
      axios.post('/scoreman?op=insertOneSchoolStudent',qs.stringify({"svr_yuming":svr_yuming,"grade":this.grade,"stdata":JSON.stringify(this.formData)})).then((res)=>{
               console.log(res.data)

               this.$alert(res.data, '提示', {
                  confirmButtonText: '确定',                 
                })               
           }).catch((res)=>{             
           })         
    },

    findList2() {
               this.tablePage2.totalResult = this.svrTeacherData.length
               this.teacherData = this.svrTeacherData.slice((this.tablePage2.currentPage - 1) * this.tablePage2.pageSize, this.tablePage2.currentPage * this.tablePage2.pageSize)       

   },

    handlePageChange2 ({ currentPage, pageSize }) {
              this.tablePage2.currentPage = currentPage
              this.tablePage2.pageSize = pageSize
              this.findList2()
            },

        //增加单个教师       
      submitTeacherEvent () {
        let svr_yuming=localStorage.getItem('svr_yuming')
        axios.post('/scoreman?op=insertOneSchoolTeacher',qs.stringify({"svr_yuming":svr_yuming,"teacherdata":JSON.stringify(this.formDataTeacher)})).then((res)=>{
              console.log(res.data)

              this.$alert(res.data, '提示', {
                 confirmButtonText: '确定',                 
               })               
          }).catch((res)=>{             
          })         
   },
          
		}
	  };
	</script>
	<style lang="scss" scoped>

  </style>
  